<template>
	<div class="chat-item" :class="[active ? 'active' : '', chat.pinned ? 'pinned' : '']" @contextmenu.prevent="showRightMenu($event)">
		<div class="chat-left">
			<head-image :url="chat.headImage" :name="chat.showName" :size="42"
				:id="chat.type == 'PRIVATE' ? chat.targetId : 0" :isShowUserInfo="false"></head-image>
			<div v-show="chat.unreadCount > 0" class="unread-text">{{ chat.unreadCount }}</div>
		</div>
		<div class="chat-right">
			<div class="chat-name">
				<div class="chat-name-text">
					<div>{{ chat.showName }}</div>
					<el-tag v-if="chat.type == 'GROUP'" size="mini" effect="dark">群</el-tag>
					<el-tag v-if="chat.pinned" size="mini" effect="plain" type="warning">置顶</el-tag>
				</div>
				<div class="chat-time-text">{{ showTime }}</div>
			</div>
			<div class="chat-content">
				<div class="chat-at-text">{{ atText }}</div>
				<div class="chat-send-name" v-show="isShowSendName">{{ chat.sendNickName + ':&nbsp;' }}</div>
				<div class="chat-content-text" v-if="!hasDraft" v-html="$emo.transform(chat.lastContent)"></div>
				<div class="chat-draft-content" v-if="hasDraft">
					<span class="draft-label">[草稿]</span>
					<span class="draft-text" v-html="$emo.transform(draftContent)"></span>
				</div>
			</div>
		</div>
		<right-menu v-show="rightMenu.show" :pos="rightMenu.pos" :items="rightMenu.items"
			@close="rightMenu.show = false" @select="onSelectMenu"></right-menu>
	</div>

</template>

<script>
import HeadImage from '../common/HeadImage.vue';
import RightMenu from '../common/RightMenu.vue';

export default {
	name: "chatItem",
	components: {
		HeadImage,
		RightMenu
	},
	data() {
		return {
			rightMenu: {
				show: false,
				pos: {
					x: 0,
					y: 0
				},
				items: []
			},
			// 用于强制响应式更新的标记
			draftUpdateFlag: 0
		}
	},
	props: {
		chat: {
			type: Object
		},
		active: {
			type: Boolean
		},
		index: {
			type: Number
		}
	},
	computed: {
		isShowSendName() {
			if (!this.chat.sendNickName) {
				return false;
			}
			let size = this.chat.messages.length;
			if (size == 0) {
				return false;
			}
			// 只有群聊的普通消息需要显示名称
			let lastMsg = this.chat.messages[size - 1];
			return this.$msgType.isNormal(lastMsg.type)
		},
		showTime() {
			return this.$date.toTimeText(this.chat.lastSendTime, true)
		},
		atText() {
			if (this.chat.atMe) {
				return "[有人@我]"
			} else if (this.chat.atAll) {
				return "[@全体成员]"
			}
			return "";
		},
		// 检查是否有草稿（增加响应式标记依赖）
		hasDraft() {
			// 依赖draftUpdateFlag确保响应式更新
			this.draftUpdateFlag;
			
			const chatId = `${this.chat.type}-${this.chat.targetId}`;
			const draft = this.$store.state.chatStore.drafts[chatId];
			if (!draft) return false;
			
			// 检查草稿内容是否有实际内容（排除纯HTML标签和空白字符）
			const trimmedDraft = draft.trim();
			const emptyPatterns = [
				'',
				'<div>&nbsp;</div>',
				'<br>',
				'<div><br></div>',
				'<p><br></p>',
				'<div></div>',
				'<p></p>',
				'&nbsp;'
			];
			
			const hasValidContent = !emptyPatterns.includes(trimmedDraft) && 
				   trimmedDraft.replace(/(<[^>]*>)|(&nbsp;)|\s/g, '').length > 0;
			
			console.log('检查草稿状态:', chatId, hasValidContent, draft.slice(0, 30));
			return hasValidContent;
		},
		// 获取草稿内容（增加响应式标记依赖）
		draftContent() {
			// 依赖draftUpdateFlag确保响应式更新
			this.draftUpdateFlag;
			
			const chatId = `${this.chat.type}-${this.chat.targetId}`;
			const draft = this.$store.state.chatStore.drafts[chatId] || '';
			// 如果草稿内容为空，返回空字符串
			return this.hasDraft ? draft : '';
		}
	},
	mounted() {
		// 监听草稿状态变化事件
		this.$eventBus.$on('draftStateChanged', this.onDraftStateChanged);
	},
	beforeDestroy() {
		// 移除事件监听
		this.$eventBus.$off('draftStateChanged', this.onDraftStateChanged);
	},
	methods: {
		showRightMenu(e) {
			// 动态生成菜单项
			this.rightMenu.items = [
				{
					key: 'TOP',
					name: this.chat.pinned ? '取消置顶' : '置顶',
					icon: this.chat.pinned ? 'el-icon-bottom' : 'el-icon-top'
				}, 
				{
					key: 'DELETE',
					name: '删除',
					icon: 'el-icon-delete'
				}
			];
			
			this.rightMenu.pos = {
				x: e.x,
				y: e.y
			};
			this.rightMenu.show = "true";
		},
		onSelectMenu(item) {
			this.$emit(item.key.toLowerCase(), this.index);
		},
		// 响应草稿状态变化
		onDraftStateChanged() {
			// 更新响应式标记，触发计算属性重新计算
			this.draftUpdateFlag++;
			console.log('ChatItem响应草稿状态变化:', this.chat.showName, this.draftUpdateFlag);
		}
	}
}
</script>

<style lang="scss">
.chat-item {
	height: 50px;
	display: flex;
	position: relative;
	padding: 5px 10px;
	align-items: center;
	background-color: var(--im-background);
	white-space: nowrap;
	cursor: pointer;

	&:hover {
		background-color: var(--im-background-active);
	}

	&.active {
		background-color: var(--im-background-active-dark);
	}
	
	&.pinned {
		background-color: #fdf6ec;
		border-left: 3px solid #e6a23c;
		
		&:hover {
			background-color: #faecd8;
		}
		
		&.active {
			background-color: #f2c572;
		}
	}

	.chat-left {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;

		.unread-text {
			position: absolute;
			background-color: #f56c6c;
			right: -4px;
			top: -8px;
			color: white;
			border-radius: 30px;
			padding: 1px 5px;
			font-size: 10px;
			text-align: center;
			white-space: nowrap;
			border: 1px solid #f1e5e5;
		}
	}


	.chat-right {
		flex: 1;
		display: flex;
		flex-direction: column;
		padding-left: 10px;
		text-align: left;
		overflow: hidden;

		.chat-name {
			display: flex;
			line-height: 20px;
			height: 20px;

			.chat-name-text {
				flex: 1;
				display: flex;
				align-items: center;
				font-size: var(--im-font-size);
				white-space: nowrap;
				overflow: hidden;

				.el-tag {
					min-width: 22px;
					text-align: center;
					border-radius: 10px;
					border: 0;
					height: 16px;
					line-height: 16px;
					font-size: 10px;
					margin-left: 2px;
					opacity: 0.8;
					
					&:not([class*="el-tag--warning"]) {
						background-color: #2830d3;
					}

				}
			}

			.chat-time-text {
				font-size: var(--im-font-size-smaller);
				text-align: right;
				color: var(--im-text-color-light);
				white-space: nowrap;
				overflow: hidden;
				padding-left: 10px;
			}
		}

		.chat-content {
			display: flex;
			line-height: 22px;

			.chat-at-text {
				color: #c70b0b;
				font-size: var(--im-font-size-smaller);
			}

			.chat-send-name {
				font-size: var(--im-font-size-small);
				color: var(--im-text-color-light);
			}


			.chat-content-text {
				flex: 1;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				font-size: var(--im-font-size-small);
				color: var(--im-text-color-light);

				img {
					width: 20px !important;
					height: 20px !important;
					vertical-align: bottom;
				}
			}

			.chat-draft-content {
				flex: 1;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				font-size: var(--im-font-size-small);
				color: var(--im-text-color-light);

				.draft-label {
					color: #e6a23c;
					font-weight: 600;
					margin-right: 4px;
				}

				.draft-text {
					color: var(--im-text-color-light);
				}

				img {
					width: 20px !important;
					height: 20px !important;
					vertical-align: bottom;
				}
			}

		}
	}
}
</style>
